import { parameters } from '../../constants/parameters';
import { Role } from '../../entities/role';
import * as genericApi from './generic-api';

export const list = async (token: string): Promise<Role[]> => {
  const url = `${parameters.api.baseUrl}/roles-crud`;

  return genericApi.listWithoutPagination<Role>(token, url, { sort: 'name', employee: 1 });
};
